import { Button } from "@shltelemedicine/shl-ui-lib";
import NextPrevIcon from "../../NextPrevIcon/NextPrevIcon";

type PagingProps = {
  total: number;
  curPage: number;
  itemsPerPage: number;
  onNext?: () => void;
  onBack?: () => void;
  nextDisabled?: boolean;
  backDisabled?: boolean;
};

const Paging = ({
  curPage,
  itemsPerPage,
  total,
  onNext,
  onBack,
  nextDisabled,
  backDisabled,
}: PagingProps) => {
  const nextHandler = () => {
    onNext && !nextDisabled && onNext();
  };

  const backHandler = () => {
    onBack && !backDisabled && onBack();
  };

  const start =
    total === 0 ? 0 : itemsPerPage * (curPage + 1) - itemsPerPage + 1;
  const end = Math.min(itemsPerPage * (curPage + 1), total);

  return (
    <div className="d-flex align-items-center text-nowrap">
      <span className="font-md muted-color">
        {start}-{end}
      </span>
      <div className="mx-2"></div>
      <div className="d-flex align-items-center">
        <Button
          variant=""
          className="p-0"
          onClick={backHandler}
          disabled={backDisabled}
        >
          <NextPrevIcon disabled={backDisabled} />
        </Button>
        <Button
          variant=""
          className="p-0"
          onClick={nextHandler}
          disabled={nextDisabled}
        >
          <NextPrevIcon next disabled={nextDisabled} />
        </Button>
      </div>
    </div>
  );
};
export default Paging;
